var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Froppy disk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.707 10.293-8-8A1 1 0 0 0 53 2H7a5.006 5.006 0 0 0-5 5v50a5.006 5.006 0 0 0 5 5h50a5.006 5.006 0 0 0 5-5V11a1 1 0 0 0-.293-.707ZM48 4v16a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1V4ZM10 60V35a3 3 0 0 1 3-3h38a3 3 0 0 1 3 3v25Zm50-3a3 3 0 0 1-3 3h-1V35a5.006 5.006 0 0 0-5-5H13a5.006 5.006 0 0 0-5 5v25H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7v16a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3V4h2.586L60 11.414Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#001833",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 19h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1Zm1-11h4v9h-4ZM47 45H17a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2ZM47 39H17a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2ZM47 51H17a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#001833",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIc);
export default __webpack_public_path__ + "static/media/save-ic.1f26fc11373b652a194ae53ebcb2b3a9.svg";
export { ForwardRef as ReactComponent };